import { paramCase } from "change-case";
import { typeOfMemberValue } from "./utils.js";
import { capitalize } from "vue";
function extendMember(member) {
  var _a;
  if (member.type) {
    const typeString = member.type.name ?? ((_a = member.type.names) == null ? void 0 : _a[0]);
    delete member.type;
    if (typeString) {
      member.types = extractMemberTypes(typeString);
    }
  }
  if (member.name) {
    member.label = paramCase(member.name);
  }
  if (member.description) {
    member.description = capitalize(member.description);
  }
}
function extendBinding(member, defaults) {
  var _a;
  const defaultValue = (_a = Object.entries(defaults).find(([name]) => {
    return name === member.name;
  })) == null ? void 0 : _a[1];
  const defaultType = typeOfMemberValue(defaultValue);
  delete member.defaultValue;
  if (defaultValue !== void 0) {
    member.initialValue = defaultValue;
    member.defaultValue = defaultValue;
  }
  if (defaultType) {
    member.defaultType = defaultType;
  }
}
function extractMemberTypes(typeString) {
  return typeString.split("|").map((type) => type.trim().toLowerCase());
}
function extendEvent(event) {
  var _a, _b;
  const types = (_b = (_a = event.type) == null ? void 0 : _a.names) == null ? void 0 : _b[0];
  delete event.type;
  if (types) {
    event.types = extractMemberTypes(types);
  }
}
export {
  extendBinding,
  extendEvent,
  extendMember
};
//# sourceMappingURL=info_extend.js.map
